import { render } from "./RestaurantContactPerson.vue?vue&type=template&id=48ec5924&scoped=true"
import script from "./RestaurantContactPerson.vue?vue&type=script&lang=js"
export * from "./RestaurantContactPerson.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-48ec5924"

export default script